module.exports = __webpack_public_path__ + "static/media/thumbnail.307d6358.jpg";